/**
 * Country List Redux Reducer
 */

import * as actions from '../actions/countries';

import { Success } from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

type ReducerState = ICountryListState;
type Handler<K = undefined> = ReducerHandler<ReducerState, K>;

const defaultList = [];

const initialState: ReducerState = {
  countries: defaultList,
  postalCodes: {},
  states: {},
};

const receiveCountriesHandler: Handler<Success<any, ICountryActionPayload>> =
  (state, { result: { countries, postalCodes } }) => ({
    ...state,
    countries,
    postalCodes,
  });

const receiveStatesForCountryHandler: Handler<Success<ICountry, ICountryStateActionPayload>> = (state, payload) => ({
  ...state,
  states: {
    ...state.states,
    [payload.result.countryId]: payload.result.states,
  },
});

export default reducerWithInitialState(initialState)
  .case(actions.fetchCountries.done, receiveCountriesHandler)
  .case(actions.fetchStatesForCountry.done, receiveStatesForCountryHandler);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/reducers/countries.ts